/* Anherb cart drawer hydration and submit safety.
   Hydrate immediately because a one-shot IntersectionObserver can miss the
   lazy placeholder. Skip fetching when section markup is already present,
   which also prevents re-entrant hydration after a section render. */

function guardMiniCartSubmit(root = document) {
  const form = root.querySelector('form.mini-cart');
  if (!form || form.__anhGuarded) return;

  form.__anhGuarded = true;
  form.addEventListener('submit', event => {
    const viaCheckout = event.submitter?.getAttribute('name') === 'checkout';
    if (viaCheckout) return;

    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
}

class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');

    if (this.querySelector('form.mini-cart')) {
      guardMiniCartSubmit(this);
      return;
    }

    this.hydrate();
  }

  hydrate() {
    if (this.hydrationPromise) return this.hydrationPromise;

    this.hydrationPromise = fetch(this.dataset.url)
      .then(response => {
        if (!response.ok) throw new Error('Mini cart request failed: ' + response.status);
        return response.text();
      })
      .then(html => {
        const target = document.getElementById('mini-cart');
        if (!target) return;

        target.innerHTML = this.getSectionInnerHTML(html, '.shopify-section');
        guardMiniCartSubmit(target);
        document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(error => {
        this.hydrationPromise = null;
        console.error(error);
      });

    return this.hydrationPromise;
  }
  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }

    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    guardMiniCartSubmit(document.getElementById('mini-cart'));
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
